<template>
  <transition name="slide-y-transition" appear mode="out-in">
    <v-card
      tile
      class="mb-4 d-flex flex-column"
      :class="[
        $style.card,
        isMissing && $style.missing,
        (isNew || isDiff) && $style.new
      ]"
    >
      <div class="d-flex flex-grow-1 justify-space-between px-4 py-2">
        <div
          class="d-flex align-center justify-center"
          :class="[
            $style.iconContainer,
            isMissing && $style.missingBg,
            (isNew || isDiff) && $style.newBg
          ]"
        >
          <v-icon color="white" small v-if="isMissing">mdi-minus</v-icon>
          <div v-else>
            <transition name="scale-transition" mode="out-in">
              <v-icon
                color="white"
                v-if="checked"
                :key="checked"
                @click="setChecked(false)"
                >mdi-check</v-icon
              >
              <div v-else @click="setChecked(true)" :class="$style.checkbox" />
            </transition>
          </div>
        </div>
        <div class="d-flex flex-column">
          <span class="text-subtitle-2 text--secondary">Tåg</span>
          <span class="font-weight-medium">{{ itemData.train_number }}</span>
        </div>
        <div class="d-flex flex-column">
          <span class="text-subtitle-2 text--secondary">Avvikelse</span>
          <span class="font-weight-medium">{{
            trainDeviationTypes[itemData.deviation_type]
          }}</span>
        </div>
        <div class="d-flex flex-column" v-if="!isCanceledStop">
          <span class="text-subtitle-2 text--secondary">Sträcka</span>
          <span class="font-weight-medium"
            >{{ itemData.from }} - {{ itemData.to }}</span
          >
        </div>
        <div class="d-flex flex-column" v-if="isCanceledStop">
          <span class="text-subtitle-2 text--secondary">Platser</span>
          <span class="font-weight-medium">{{ itemData.places }}</span>
        </div>
        <div class="d-flex flex-column" v-if="!isCanceledStop">
          <span class="text-subtitle-2 text--secondary">Tid</span>
          <span class="font-weight-medium"
            >{{ itemData.departure | timeFormat }} -
            {{ itemData.arrival | timeFormat }}</span
          >
        </div>
        <div class="d-flex flex-column" v-if="showCancellationFields">
          <!-- <span class="text-subtitle-2 text--secondary">Orsak</span> -->
          <DuaMessageReasonField :uuid="item.uuid" :item="item" />
        </div>
      </div>

      <v-divider></v-divider>
      <template v-if="showCancellationFields">
        <DuaMessageCancellationFields
          v-if="!showAddCancelSection"
          :missing="isMissing"
          :item="item"
          :uuid="item.uuid"
          :validating-form="validatingForm"
        />
        <template v-for="section in cancel_sections" v-else>
          <DuaMessageCancelSection
            :departure="itemData.departure"
            :cancel-sections="cancel_sections"
            :show-delete-button="cancel_sections.length > 1"
            @remove="onRemoveCancelSection"
            :key="section.index"
            :index="section.index"
            :missing="isMissing"
            :item="item"
            :refForm="refForm"
            :uuid="item.uuid"
            :search-train="searchTrain"
            :validating-form="validatingForm"
          />
        </template>
      </template>
      <v-divider></v-divider>
      <div style="display: flex">
        <v-btn
          style="flex: 1"
          v-if="showAddCancelSection"
          @click="addCancellation"
          text
          >Lägg till inställelsesträcka</v-btn
        >
        <v-divider vertical />
        <v-btn
          style="flex: 1"
          v-if="showAddCancelSection"
          @click="addCancelSectionAllPlaces"
          text
          >Lägg till för alla platser</v-btn
        >
      </div>

      <template v-if="false">
        <v-divider></v-divider>
        <DuaMessageMiscFields
          :uuid="item.uuid"
          :deviation-type="itemData.deviation_type"
        />
      </template>
      <template v-if="duaMessageStatus">
        <v-divider></v-divider>
        <DuaMessageOk
          v-if="duaMessageStatus.ok"
          :message="duaMessageStatus.response_data"
        />
        <DuaMessageUnknown v-else-if="duaMessageStatus.unknown" />
        <DuaMessageError
          v-else-if="duaMessageStatus.notOk"
          :error-message="duaMessageStatus.response_data"
        />
      </template>
    </v-card>
  </transition>
</template>

<script>
import trainDeviationTypes from '@/common/trainDeviationTypes'
import DuaMessageCancellationFields from './DuaMessageCancellationFields'
import DuaMessageOk from './DuaMessageOk'
import DuaMessageUnknown from './DuaMessageUnknown'
import DuaMessageError from './DuaMessageError'
import DuaMessageMiscFields from './DuaMessageMiscFields'
import { format } from 'date-fns'
import { get } from 'vuex-pathify'
import DuaMessageReasonField from './DuaMessageReasonField'
import DuaMessageCancelSection from './DuaMessageCancelSection'
import gql from 'graphql-tag'

export default {
  name: 'DuaMessageTripCard',

  props: {
    validatingForm: Boolean,
    item: Object,
    refForm: null,
    type: {
      type: String,
      default: () => 'current'
    }
  },

  components: {
    DuaMessageCancellationFields,
    DuaMessageOk,
    DuaMessageUnknown,
    DuaMessageError,
    DuaMessageMiscFields,
    DuaMessageReasonField,
    DuaMessageCancelSection
  },

  filters: {
    timeFormat(date) {
      return format(new Date(date), 'HH:mm')
    }
  },

  apollo: {
    searchTrain: {
      query: gql`
        query searchTrain($filter: SearchTrainInput!) {
          searchTrain(filter: $filter) {
            public_number
            places {
              type
              advertised
              location
              location_long_name
            }
          }
        }
      `,
      fetchPolicy: 'cache-and-network',
      variables() {
        return {
          filter: {
            train_number: this.item.text.train_number,
            date: format(new Date(this.item.text.departure), 'yyyy-MM-dd')
          }
        }
      }
    }
  },

  data: () => ({
    trainDeviationTypes
  }),

  methods: {
    setChecked(value) {
      this.$store.dispatch('duaMessage/setFormChecked', {
        uuid: this.item.uuid,
        value
      })
    },

    onRemoveCancelSection(index) {
      this.$store.dispatch('duaMessage/updateForm', {
        uuid: this.item.uuid,
        prop: 'cancel_sections',
        value: Object.assign({}, this.form[this.item.uuid])
          .data.cancel_sections.filter(x => x.index !== index)
          .map((x, index, arr) => {
            if (index === arr.length - 1) {
              return Object.assign(
                {},
                {
                  ...x,
                  index,
                  arrival: +new Date(this.item.text.arrival),
                  to: this.item.text.to
                }
              )
            }
            return Object.assign(
              {},
              {
                ...x,
                index
              }
            )
          })
      })
    },

    addCancellation() {
      const newCancellation = {
        from: null,
        to: this.item.text.to,
        dua_cancellation_code: 'ANA027',
        dua_reference_code: 'ANA075',
        estimated_time_at_location: null,
        departure: null,
        arrival: +new Date(this.item.text.arrival),
        index: this.form[this.item.uuid].data.cancel_sections.length
      }

      const form = Object.assign({}, this.form)

      const cancel_sections = form[this.item.uuid].data.cancel_sections.map(x =>
        Object.assign({}, x)
      )

      this.$store.dispatch('duaMessage/updateForm', {
        uuid: this.item.uuid,
        prop: 'cancel_sections',
        value: [...cancel_sections, newCancellation]
      })
    },

    addCancelSectionAllPlaces() {
      if (!this.searchTrain || !this.searchTrain.places) return
      let arrivalDeparturePlace = []
      const fromToPlaces = (this.searchTrain?.places || []).reduce(
        (acc, place) => {
          if (arrivalDeparturePlace.length === 0 && place.type === 'Avgang') {
            arrivalDeparturePlace.push(place)
          }

          if (arrivalDeparturePlace.length === 1 && place.type === 'Ankomst') {
            arrivalDeparturePlace.push(place)
          }

          if (arrivalDeparturePlace.length === 2) {
            acc.push(arrivalDeparturePlace)
            arrivalDeparturePlace = []
          }

          return acc
        },
        []
      )
      const form = Object.assign({}, this.form)
      const prevCancellation = form[this.item.uuid]?.data.cancel_sections.length
        ? form[this.item.uuid].data.cancel_sections?.[
            form[this.item.uuid].data.cancel_sections.length - 1
          ]
        : null

      const newCancellations = fromToPlaces.map((x, i) => {
        return {
          from: x[0].location,
          to: x[1].location,
          dua_cancellation_code: prevCancellation
            ? prevCancellation.dua_cancellation_code
            : 'ANA027',
          dua_reference_code: prevCancellation
            ? prevCancellation.dua_reference_code
            : 'ANA075',
          estimated_time_at_location: null,
          departure: +new Date(x[0].advertised),
          arrival: +new Date(x[1].advertised),
          index: i
        }
      })

      this.$store.dispatch('duaMessage/updateForm', {
        uuid: this.item.uuid,
        prop: 'cancel_sections',
        value: newCancellations
      })
    }
  },

  computed: {
    model: get('duaMessage/model'),
    form: get('duaMessage/form'),
    diffTrainDeviations: get('duaMessage/diffTrainDeviations'),
    diffTrainDeviationsCancelSections: get(
      'duaMessage/diffTrainDeviationsCancelSections'
    ),

    cancel_sections() {
      return (
        (this.form[this.item.uuid]?.data?.cancel_sections || [])
          .slice()
          .sort((a, b) => a.index - b.index) || []
      )
    },

    checked() {
      return this.form[this.item.uuid]._checked
    },

    duaMessageStatus() {
      const item = this.model?.body?.find(
        x => x?.trip_uuid === this.itemData.uuid
      )

      if (!item) {
        return null
      }

      const messageStatus = {
        ok: item.status === 'Ok',
        notOk: item.status === 'Error',
        unknown: item.status === 'Unknown',
        response_data: item.response_data
      }

      if (messageStatus.ok) {
        messageStatus.response_data = `Status: behandlad${
          item.updated ? ' ' + format(new Date(item.updated), 'HH:mm') : ''
        }`
      }

      return messageStatus
    },

    isDiff() {
      const isOldDiff = this.isCanceledStop || !this.cancel_sections.length

      if (isOldDiff) {
        return Boolean(
          this.diffTrainDeviations?.find(x => x?.trip_uuid === this.item.uuid)
        )
      }
      return this.diffTrainDeviationsCancelSections?.find(
        x => x?.trip_uuid === this.item.uuid
      )
    },

    isMissing() {
      return this.type === 'missing'
    },

    isNew() {
      return this.type === 'new'
    },

    itemData() {
      return this.item.text
    },

    isCanceledStop() {
      return ['CANCELED_STOP'].includes(this.itemData?.deviation_type)
    },

    showCancellationFields() {
      return ['CANCELED', 'PARTIAL_CANCELLATION', 'CANCELED_STOP'].includes(
        this.itemData?.deviation_type
      )
    },

    showAddCancelSection() {
      return ['CANCELED', 'PARTIAL_CANCELLATION'].includes(
        this.itemData?.deviation_type
      )
    }
  }
}
</script>

<style lang="scss" module>
.new {
  border-left: 4px solid blue !important;
}

.newBg {
  background: blue;
}

.missing {
  border-left: 4px solid red !important;
}

.missingBg {
  background: red;
}

.card {
  position: relative;
}

.iconContainer {
  position: absolute;
  top: 0;
  left: -24px;
  width: 24px;
  height: 24px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.checkbox {
  background: white;
  border-radius: 2px;
  width: 18px;
  height: 18px;
}
</style>
